import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Stack, Button } from "@mui/material";
import apiFetch from "../../../../utils/apiFetch";
import { useSnackAlert } from "../../../../contexts/SnackAlertContext";

// Keep in sync with accountSecurity.password in public/locales/en/common.json
// -- see the `translate` prop note in ./index.jsx.
const EN = {
  label: "Password",
  helper: "Change password",
  change: "Change",
  instructionsSent: "Password Instructions Sent",
  resetSuccess: "Password reset instructions sent to your email.",
  resetError: "Failed to send password reset instructions.",
};

export default function UpdatePassword({
  user,
  helperTextStyle,
  translate = true,
}) {
  const [resetPasswordSent, setResetPasswordSent] = useState(false);

  const { t: i18nT } = useTranslation("common", {
    keyPrefix: "accountSecurity.password",
  });
  const t = (key) => (translate ? i18nT(key) : EN[key]);
  const { setSnackAlert } = useSnackAlert();

  // Sends Devise reset-password instructions to the user's login email, then
  // routes to the confirmation screen. Same behavior as the legacy navbar.
  const handleChangePassword = async () => {
    try {
      await apiFetch("/users/password", {
        method: "POST",
        body: JSON.stringify({ email: user.email }),
      });
      setSnackAlert(t("resetSuccess"), "success");
      setResetPasswordSent(true);
    } catch (e) {
      setSnackAlert(t("resetError"), "error");
    }
  };

  return (
    <Box>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          mt: 2,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography variant="body1">{t("label")}</Typography>
          <Typography variant="body2" sx={helperTextStyle}>
            {t("helper")}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          size="small"
          onClick={handleChangePassword}
          disabled={resetPasswordSent}
        >
          {resetPasswordSent ? t("instructionsSent") : t("change")}
        </Button>
      </Stack>
    </Box>
  );
}
